import React from 'react'

import * as styles from './PostListContainer.module.scss'

const PostListContainer = ({ children }) => {
  return <ul className={styles.container}>{children}</ul>
}

export default PostListContainer
